import React from 'react';

export const propTypeStrings = [
  {
    name: 'Multi-family',
    description: 'Properties that have five or more residential units in a single building and may be further classified as garden style, low-rise or high-rise.',
  },
  {
    name: 'Retail',
    description: 'Grocery-anchored centers, shopping centers, power centers and strip malls.',
  },
  {
    name: 'Office',
    description: 'Mid-rise or high-rise, downtown or suburban.',
  },
  {
    name: 'Industrial',
    description: 'Flex warehouse, distribution centers, light assembly and manufacturing.',
  },
  {
    name: 'Other',
    description: 'Commercial real estate properties that do not fall under any other type listed.',
  },
];

export const propTypeStringsMR2 = [
  {
    name: 'High-rise',
    description: 'Elevator buildings which are four stories or more in height.',
  },
  {
    name: 'Low-rise',
    description: 'Walk-up buildings and elevator buildings three stories or less.',
  },
  {
    name: 'Garden-style',
    description: 'Low-rise apartments situated on a sizable landscaped plot, under one management.',
  },
  {
    name: 'Multi-family',
    description: (
      <>
        MogulREIT II is an equity vehicle that invests in only multifamily
        apartment buildings.
        <br />
        <br />
        Why multifamily? Focusing on multifamily gives us an opportunity to
        implement a value-add strategy for properties in the portfolio. When
        using this strategy, we aim to implement capital improvements that can
        permit rent increases and decrease expenses leading to potentially
        greater distributions to investors over time. If the property is sold,
        there may be additional upside, as well, for investors.
      </>
    ),
  },
];

export const geoStrings = [
  {
    name: 'West',
    description: 'AK, AZ, CA, CO, HI, ID, MT, NM, NV, OR, UT, WA, WY',
  },
  {
    name: 'Midwest',
    description: 'KS, IL, IN, IA, MI, MN, MO, ND, NE, OH, SD, WI',
  },
  {
    name: 'South',
    description: 'AL, AR, FL, GA, LA, MS, OK, TN, TX',
  },
  {
    name: 'East',
    description: 'CT, DC, DE, KY, MA, MD, ME, NC, NH, NJ, NY, PA, RI, SC, VA, VT, WV',
  },
];

export const investmentTypeStrings = [
  {
    name: 'Joint Venture Equity',
    y: 2, // What is Y? It's not defined anywhere that I can find.
    description: 'Investors in Joint Venture Equity own an interest in an entity (usually an LLC) that invests in the equity portion of a property. After all debt is paid, and any Preferred Equity distributions are made, the Joint Venture Equity investor receives a pro rata portion of a preferred return, cash flow, and any profits upon sale. Joint Venture Equity is the riskiest investment as it has the lowest priority of distributions, although it has the greatest upside potential.',
  },
  {
    name: 'Senior Debt',
    y: 3,
    description: 'Secured by a loan on the property, investors in Senior Debt are first in line to receive repayment from available cash flow, paid out on an agreed upon interest rate and term. In the event of loan default, the investors in the senior debt have the right to foreclose on the property and use the sale proceeds to repay principal, unpaid interest and any fees.',
  },
  {
    name: 'Mezzanine Debt',
    y: 8,
    description: 'Second in line for repayment are investors in Mezzanine Debt and B Notes. Mezzanine Debt is structured as a loan secured by a pledge of interest in the entity owning the property. In the event of loan default, investors may have the right to foreclose on the interests of the entity and step into ownership of the property, subject to any senior debt. B Notes are secondary tranches of senior loans with an A/B structure, and are secured by the property itself. In the event of loan default, the investors in a B Note may participate in the right to foreclose on the property and receive sale proceeds to repay principal, unpaid interest and any fees, subject to the A Note investor.',
  },
  {
    name: 'Preferred Equity',
    y: 5,
    description: 'Investors in Preferred Equity investments own an interest in the property and have a priority over the other equity investors to receive distributions of cash flow and capital invested. In the event of loan default, Preferred Equity investors may have the right to take over control and management of the property.',
  },
];

export const marketTierStrings = [
  {
    name: 'Primary',
    description: 'Locations where the broader MSAs have a population of 5 million or greater.',
  },
  {
    name: 'Secondary',
    description: 'Locations where the broader MSAs have a population between 2 – 5 million.',
  },
  {
    name: 'Tertiary',
    description: 'Locations where the broader MSAs have a population less than 2 million.',
  },
];
